import { useEffect, useLayoutEffect, useState } from "react";
import "./App.scss";
import SessionExpiredDialog from "./Components/SessionExpired/SessionExpired";
import Sidnavbar from "./Components/Sidnavbar/Sidnavbar";
import { useAppDispatch, useAppSelector } from "./Redux/Store/Hooks";
import api from "./Redux/Axios/middleware";
import { sessionExpired } from "./Redux/Slices/SessionExpired/SessionExpired";
import Loading from "./Components/Loading/Loading";
import NetworkStatus from "./Components/NetworkStatus/NetworkStatus";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { setTheme } from "./Utils/setTheme";
import { decode } from "./Utils/encodeDecode";
import { ILoginResponse } from "./Pages/Login/ILogin";
// import AdminPanel from "./Pages/AdminPanel/AdminPanel";
import { Outlet } from "react-router-dom";
import AppBarnav from "./Components/AppBar/AppBar";
import MenuBar from "./Components/MenuBar/MenuBar";
import { config } from "process";
import Layout from "./.MODULS/BOOKLET_MODUL/Components/Layout/Layout";

function Home() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(true);
  const { data } = useAppSelector((state) => state.Theme);
  const [details, setDetails] = useState<ILoginResponse>({});

  const skipedURLs = [
    "/api/ai/chat",
    "/api/dashboard/ai/chat",
    "/api/booklet/request/view/",
    "/api/booklet/request/accept",
    "/api/booklet/request/allrequest",
    "/api/booklet",
    "/api/booklet/dashboard/cart",
    "/api/booklet/dashboard/default_printer_settings",
    "/api/admin-dashboard/overall-activity",
    "/api/screen/",

  ];
  // useLayoutEffect(() => {
  //   // request

  //   api.interceptors.request.use(
  //     (config) => {
  //       console.log(config.url);

  //       if (config.url && skipedURLs.includes(config.url)) {
  //         console.log("loading false");

  //         setLoading(false);
  //       } else {
  //         console.log("loading true");

  //         setLoading(true);
  //       }

  //       return config;
  //     },
  //     (error) => {
  //       setLoading(false);
  //       return Promise.reject(error);
  //     }
  //   );

  //   // response
  //   api.interceptors.response.use(
  //     (response) => {
  //       setLoading(false);
  //       return response;
  //     },
  //     (error) => {
  //       setLoading(false);
  //       // expired token
  //       if (error.response.status === 401) {
  //         dispatch(sessionExpired(true));
  //         return;
  //       }

  //       return Promise.reject(error);
  //     }
  //   );
  // }, [dispatch]);
  useLayoutEffect(() => {
    const requestInterceptor = api.interceptors.request.use(
      (config) => {
        const url = config.url || "";

        // ✅ Check if the URL starts with any skipped base path
        const isSkippedBase = skipedURLs.some((skipUrl) =>
          url.startsWith(skipUrl)
        );

        if (isSkippedBase) {
          console.log("⏩ Skipping loading for:", url);
          setLoading(false);
        } else {
          setLoading(true);
        }

        return config;
      },
      (error) => {
        setLoading(false);
        return Promise.reject(error);
      }
    );

    const responseInterceptor = api.interceptors.response.use(
      (response) => {
        setLoading(false);
        return response;
      },
      (error) => {
        setLoading(false);
        if (error.response?.status === 401) {
          dispatch(sessionExpired(true));
        }
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.request.eject(requestInterceptor);
      api.interceptors.response.eject(responseInterceptor);
    };
  }, [dispatch]);

  useEffect(() => {
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, [data.primary_color]);

  const isAdminRole =
    details.role === "ADMIN" ||
    details.role === "TUTOR_ADMIN" ||
    details.role === "CRM_ADMIN";

  const isTutorRole =
    details.role === "TUTOR" || details.role === "UCAT_STUDENT";

  return (
    <>
      <div className={`App ${isAdminRole ? "admin-layout" : ""}`}>
        {/* 🔹 Top Menu Bar (for admins) */}
        {isAdminRole && <MenuBar />}

        {/* 🔹 Tutor Layout */}
        {isTutorRole ? (
          <Layout />
        ) : (
          <Sidnavbar />
        )}

        {/* {details.role === "ADMIN" ? <Sidnavbar /> : <AppBarnav />} */}

        <NetworkStatus />
        <SessionExpiredDialog />
        {loading && <Loading isLoading={loading} />}
      </div>
    </>
  );
}

export default Home;
